import React from 'react';

export default function Grid({
  children,
  className,
  wrapperOnly = false,
}: {
  children: React.ReactNode;
  className?: string;
  wrapperOnly?: boolean;
}): React.ReactElement {
  return (
    <div className={`section-content ${className ? className : ''}`}>
      <div className="container">
        <div className="row flex">
          {wrapperOnly ? children : <div className="col col-12">{children}</div>}
        </div>
      </div>
    </div>
  );
}
